<!-- 内容项组件 (标题+内容) -->
<template>
  <ItemCard :title="title" :index="index" :showRemove="showRemove" @remove-item="$emit('remove-item', $event)">
    <div class="item-body">
      <p>
        <span>标题</span>
        <el-input type="text" placeholder="请输入标题" v-model="localTitle" show-word-limit>
        </el-input>
      </p>
      <p>
        <span>内容</span>
        <el-input type="textarea" :rows="3" placeholder="请输入内容" v-model="text" show-word-limit>
        </el-input>
      </p>
    </div>
  </ItemCard>
</template>

<script>
import ItemCard from "./ItemCard";
import editMixin from '../mixins/editMixin';

export default {
  name: 'ContentCard',
  mixins: [editMixin],
  components: {
    ItemCard
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    index: {
      type: Number,
      default: 0
    },
    showRemove: {
      type: Boolean,
      default: true
    },
    value: {
      type: Object,
      default: () => ({
        title: '',
        text: ''
      })
    }
  },
  computed: {
    localTitle: {
      get() {
        return this.value.title
      },
      set(val) {
        this.updateValue({ title: val })
      }
    },
    text: {
      get() {
        return this.value.text
      },
      set(val) {
        this.updateValue({ text: val })
      }
    }
  },
}
</script>

<style lang="scss" scoped>
.item-body {
  font-size: 12px;
  width: 100%;

  p {
    margin: 12px 0 0;
    display: flex;
    align-items: flex-start;

    span:first-child {
      width: 40px;
      flex-shrink: 0;
      margin-right: 12px;
      font-weight: 500;
      color: #303133;
      padding-top: 4px;
    }

    .el-input {
      flex: 1;

      .el-input__inner {
        border-radius: 4px;
        border-color: #dcdfe6;
        transition: all 0.3s ease;

        &:focus {
          border-color: #409eff;
          box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.2);
        }
      }
    }

    .el-textarea {
      flex: 1;

      .el-textarea__inner {
        min-height: 80px;
        border-radius: 4px;
        border-color: #dcdfe6;
        transition: all 0.3s ease;
        font-size: 12px;
        line-height: 1.4;

        &:focus {
          border-color: #409eff;
          box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.2);
        }
      }
    }
  }
}
</style>
